import { render, staticRenderFns } from "./TextWithRightPicture.vue?vue&type=template&id=52c40eb4&"
import script from "./TextWithRightPicture.vue?vue&type=script&lang=js&"
export * from "./TextWithRightPicture.vue?vue&type=script&lang=js&"
import style0 from "./TextWithRightPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports